import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: '404',
    redirect: { name: 'suppliers' }
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: guardLogin

  },
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import(/* webpackChunkName: "suppliers" */ '../views/Suppliers'),
    beforeEnter: guardRoute,
  },
  {
    path: '/letters',
    name: 'letters',
    component: () => import(/* webpackChunkName: "letters" */ '../views/Letters.vue'),
    beforeEnter: guardRoute

  }
]

function guardRoute(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (!isLoggedIn) {
    const path = to.path
    next({
      name: 'login',
      params: { redirect: to.path }
    })
  } else {
    next()
  }
}
function guardLogin(to, from, next) {
  const isLoggedIn = store.getters.isLoggedIn
  if (isLoggedIn) {
    next({ name: 'suppliers' })
  } else {
    next()
  }
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
